import { useEffect, useState } from "react";
import { getNativeBuild, getNativeVersion } from "@cntrl/native";
import { Button } from "@cntrl/ui";
import { BUNDLE_VERSION } from "../../app/clientVersion.js";
import { switchToWaitingUpdate, useLiveUpdateReady } from "../../app/liveUpdate.js";
import styles from "./SettingsScreen.module.scss";

/**
 * Which app and which web bundle this device is running — "Version 1.1.1 (1792005385) · Web 1792004537" in the iOS
 * app, "Web 1792004537" in a browser. The web number is the bundle version live updates compare (the deployed
 * commit's unix time, the same number a lane's live-update manifest names), so it is how to tell whether a phone
 * has taken the latest bundle. When a newer bundle has downloaded and is waiting, it says so, with a Restart that
 * switches to it now.
 */
export function AppVersion() {
  const [native, setNative] = useState<{ version: string | null; build: string | null } | null>(null);

  useEffect(() => {
    let live = true;
    void Promise.all([getNativeVersion(), getNativeBuild()]).then(([version, build]) => {
      if (live) setNative({ version, build });
    });
    return () => {
      live = false;
    };
  }, []);

  const ready = useLiveUpdateReady((s) => s.ready);
  const app = native?.version ? `Version ${native.version}${native.build ? ` (${native.build})` : ""} · ` : "";
  return (
    <p className={styles.appVersion}>
      {`${app}Web ${BUNDLE_VERSION}`}
      {ready && (
        <>
          {" · Update ready · "}
          <Button variant="link" onClick={() => void switchToWaitingUpdate()}>
            Restart
          </Button>
        </>
      )}
    </p>
  );
}
